import * as Sentry from '@sentry/react';

if (import.meta.env.REACT_APP_ENV !== 'local') {
  Sentry.init({ dsn: import.meta.env.REACT_APP_SENTRY_DSN, environment: import.meta.env.REACT_APP_ENV });
}
